



















































import { Component, Prop, Watch, Mixins } from "vue-property-decorator";
import {EventBus} from '../../helpers/EventBus';
import {Element} from "../../../api/models/Element";
import {Event} from "../../../api/models/Event";
import AnalyticsMixin from "../../../mixins/AnalyticsMixin";
import PocketBlock from "@share/common/pocket/Pocket.vue";
import { getImageUrl } from "@common/ImageUrlHelper";
import { formatIntervalDate } from '@common/dateTimeHelper';
import SegmentControl from  "@share/common/segment/Segment.vue";
import { DateTime } from 'luxon';
import { EventType } from "@share/common/types/enums/EventType";

@Component({
    name: 'EventSwitcher',
    components: { PocketBlock, SegmentControl }
})
export default class EventSwitcher extends Mixins(AnalyticsMixin) {
    @Prop({required: true}) isVisible: boolean;

    activeSectionType: EventType = EventType.upcoming;
    now = DateTime.local();

    mounted() {
        this.checkSelectedExist();
    }

    checkSelectedExist() {
        if(!this.list.some((event: Element) => event.id === this.selected) && this.list.length > 0) {
            this.selected = this.list[0]?.id;
        }
        else if(!this.list.length) {
            this.selected = ''
        }

        this.setEventId(this.selected);
    }

    get list(): Event[] {
        return this.$store.getters["events/sortedListByEndDateDesc"].filter((event: Event) => event.beginAt || event.endAt );
    }

    // отфильтрованный список для выбранного сегмента
    get filteredEventList() {
        return this.activeSectionType === EventType.upcoming
            ? this.list.filter((event: Event) => this.now < this.eventEndAt(event)).sort((a, b) => {
                if (a.beginAt < b.beginAt) {
                    return -1;
                }
                if (a.beginAt > b.beginAt) {
                    return 1
                }
                return 0;
            })
            : this.list.filter((event: Event) => this.now >= this.eventEndAt(event));
    }

    get selectedEvent() {
        return this.$store.getters["events/selectedEvent"];
    }

    get selected(): string {
        return this.$store.state.events.selected;
    }

    set selected(value: string) {
        this.$store.dispatch('events/setSelected', value);
        if (this.$route.name != 'Home' && this.$route.name != null) {
            this.$router.push({name: 'Home', params: { backend: this.$route.params.backend, eventId: value}});
            EventBus.$emit('eventChanged');
        }
        else {
            this.$router.push({name: this.$route.name || 'Home', params: { ...this.$route.params, eventId: value}});
            EventBus.$emit('eventChanged');
        }

        this.setEventId(this.selected);
    }

    get lang() {
        return this.$store.state.session?.language || navigator.language.split('-')[0] || "en";
    }

    get segmentData()  {
        return [{
            active: this.activeSectionType === EventType.upcoming,
            title: this.$t('common.upcoming'),
            value: EventType.upcoming
        },
        {
            active: this.activeSectionType === EventType.past,
            title: this.$t('common.past'),
            value: EventType.past
        }]
    }

    @Watch('isVisible')
    onChangeVisibility(newValue: number) {
        if (newValue) {
            this.recalcNow();
        }
    }

    recalcNow() {
        this.now = DateTime.local();
    }

    eventDates(event: Event) {
        if (!event.beginAt) {
            return '';
        }

        return formatIntervalDate(event.beginAt.toObject(), event.endAt ? event.endAt.toObject() : event.beginAt.endOf('day').toObject(), this.lang);
    }

    eventLogo(event: Event) {
        if (event && event.imageFileId) {
            return getImageUrl(this.$route.params.backend, event.imageFileId, 200)
        }
        return '';
    }

    // возвращает время окончания мероприятия
    eventEndAt(event: Event) {
        return event.endAt ?? event.beginAt.endOf('day');
    }

    changeType(value: EventType) {
        this.activeSectionType = value;
        this.recalcNow();
    }

    close() {
        this.$emit('close');
    }
}
